import { GetTaxCommissionIncomeDetailsResp } from "@/apis/family_application/requests";

export function hasTaxCommissionErrors(
  response: GetTaxCommissionIncomeDetailsResp
) {

  return response.some((person) => {
    return person.errors.length > 0
  })
}
